import { MESSAGE_TYPE } from '@constants/messages';

/**
 * Return the correct message type for API based on message category
 * @param {string} category Message category
 * @returns {string} Message type
 */
export const getMessageType = category => {
  if (category && category !== MESSAGE_TYPE.ALL) {
    return category;
  }

  return undefined;
};
